module.exports = __webpack_public_path__ + "static/Laurie Rubel.6a8a9006.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Laurie Rubel.jpg
// module id = 1151
// module chunks = 35783957827783